export default __webpack_public_path__ + "static/media/shoba.34bfff16.jpeg";